import { createContext } from "react";
import { defaultInventory, Inventory } from "../Models/Inventory";
  /**
 * Context for the "Inventory" model
 */

export const InventoryContext = createContext<Inventory>(defaultInventory);
